import React, { useEffect } from "react";
import Header from "../component/Header";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  useEffect(() => {
    switch (role) {
      case "China":
        navigate("/china");
        break;
      case "CustomerService":
        navigate("/customerService");
        break;
      case "Finance":
        navigate("/finance");
        break;
      case "Shipment":
        navigate("/shipment");
        break;
      case "Admin":
        navigate("/admin");
        break;
      case "Delivery":
        navigate("/delivery");
        break;
      case "Adama":
        navigate("/Adama");
        break;
      case "Editor":
        navigate("/Editing");
        break;
      default:
        navigate("/");
    }
  }, [role, navigate]); // Add role and navigate as dependencies

  return (
    <>
      <Header />
      <div className="min-h-screen flex flex-col items-center justify-center bg-white text-black">
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">
            Employee Management System
          </h1>
          <p className="text-lg text-gray-700">Welcome to Hulu Order portal</p>
        </header>

        <main className="text-center max-w-md">
          <p className="text-gray-800">
            Manage inventories. Managing employees. Track shipments. Generate
            reports. And much more...
          </p>
        </main>

        <footer className="text-center mt-12 text-gray-500 text-sm">
          © {new Date().getFullYear()} Husus Trading PLC.
        </footer>
      </div>
    </>
  );
}

export default Home;
